export class RodeoEventOrder {
    rodeoEventId: number;
    slack: boolean;
    eventOrder: number;

    constructor() { }

    public static create(rodeoEventId: number, slack: boolean, eventOrder: number) : RodeoEventOrder
    {
        let newRodeoEventOrder = new RodeoEventOrder();
        newRodeoEventOrder.rodeoEventId = rodeoEventId;
        newRodeoEventOrder.slack = slack;
        newRodeoEventOrder.eventOrder = eventOrder;

        return newRodeoEventOrder;
    }
}


// WEBPACK FOOTER //
// ./src/model/rodeoEventOrder.ts